import { CriteriaQuery } from 'src/app/fpx/common/models/criteria.model';
import {
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  LookUpFn,
  ModifyFn,
} from './http-provider.model';

export declare interface BaseFpxDataService<T> {
  findByKey?(payload: T): FindByKeyFn<T>;
  findAll?(criteriaQuery : CriteriaQuery): FindAllFn<T>;
  create(payload: T): CreateFn<T>;
  lookup(key: unknown): LookUpFn<T>;
  modify(payload: T): ModifyFn<T>;
}
